module.exports = __webpack_public_path__ + "img/L3_zoom.2c28101e.svg";